"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pieve-torina": {
    "5b98b019": [{
      "hkey": "75dffe64",
      "slug": "pieve-torina",
      "name": "Pieve Torina",
      "primary": true,
      "skipSearch": false
    }],
    "capecchiara": [{
      "hkey": "75dffe64",
      "slug": "pieve-torina",
      "name": "Pieve Torina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bd824c67": [{
      "hkey": "2441e34a",
      "slug": "capodacqua-tazza",
      "name": "Capodacqua-Tazza",
      "primary": true,
      "skipSearch": false
    }],
    "capodacqua": [{
      "hkey": "2441e34a",
      "slug": "capodacqua-tazza",
      "name": "Capodacqua-Tazza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e9e08354": [{
      "hkey": "75dffe64",
      "slug": "pieve-torina",
      "name": "Pieve Torina",
      "primary": true,
      "skipSearch": false
    }],
    "casavecchia-alta": [{
      "hkey": "75dffe64",
      "slug": "pieve-torina",
      "name": "Pieve Torina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d66ee1d9": [{
      "hkey": "75dffe64",
      "slug": "pieve-torina",
      "name": "Pieve Torina",
      "primary": true,
      "skipSearch": false
    }],
    "giulo": [{
      "hkey": "75dffe64",
      "slug": "pieve-torina",
      "name": "Pieve Torina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "68ff7bdc": [{
      "hkey": "2441e34a",
      "slug": "capodacqua-tazza",
      "name": "Capodacqua-Tazza",
      "primary": true,
      "skipSearch": false
    }],
    "tazza": [{
      "hkey": "2441e34a",
      "slug": "capodacqua-tazza",
      "name": "Capodacqua-Tazza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pieve-torina"
    }],
    "c36dd753": [{
      "hkey": "75dffe64",
      "slug": "pieve-torina",
      "name": "Pieve Torina",
      "primary": true,
      "skipSearch": false
    }],
    "torricchio": [{
      "hkey": "75dffe64",
      "slug": "pieve-torina",
      "name": "Pieve Torina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;